import { render, staticRenderFns } from "./SelectPayWay.vue?vue&type=template&id=1515f3b1&scoped=true&"
import script from "./SelectPayWay.vue?vue&type=script&lang=js&"
export * from "./SelectPayWay.vue?vue&type=script&lang=js&"
import style0 from "./SelectPayWay.vue?vue&type=style&index=0&id=1515f3b1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1515f3b1",
  null
  
)

export default component.exports